export const formatForDownload = (data) => {
  if (typeof data === 'object') {
    return JSON.stringify(data);
  }

  return data;
};
